import { bopApi } from '@/lib/api/client';

const LIST_PATH = 'v1/funds/customerReferences/get';
const ADD_PATH = 'v1/funds/customerReferences/add';

/** Wire item from GET v1/funds/customerReferences/get (bare array, last created first) */
export interface CustomerReference {
  account_holder_id: string;
  account_holder_name: string;
  segment: string;
  reference: string;
  generated_at: string;
}

export interface AddCustomerReferenceResponse {
  success: boolean;
  error?: string;
}

export const getCustomerReferences = () => bopApi.get(LIST_PATH).json<CustomerReference[]>();

export const addCustomerReference = (accountHolderId: string) => bopApi.post(ADD_PATH, { json: { accountHolderId } }).json<AddCustomerReferenceResponse>();
